<template>
  <div class="facilities-count-with-owner-indicator">
    <IsOwnerIndicator :isOwner="isOwner" :height="height" :tooltip="tooltip" />
    <span>
      {{ isOwner ? facilitiesCount.owner : facilitiesCount.not_owner }}
    </span>
  </div>
</template>

<script>
import { mapState } from "vuex";
import IsOwnerIndicator from "@/components/Permissions/IsOwnerIndicator.vue";

export default {
  name: "FacilitiesCount",
  components: { IsOwnerIndicator },
  props: {
    isOwner: {
      type: Boolean,
      required: true
    },
    height: {
      type: String,
      default: "22px"
    },
    company: {
      type: Object,
      required: false
    }
  },
  computed: {
    ...mapState({
      facilitiesAccessCount: state =>
        state.company.company.company_user.facilities_access_count
    }),
    tooltip() {
      return this.$t(
        `message.common.facilitiesCountIs${
          this.isOwner ? "" : "Not"
        }OwnerTooltip`
      );
    },
    facilitiesCount() {
      return this.company
        ? this.company.company_user.facilities_access_count
        : this.facilitiesAccessCount;
    }
  }
};
</script>

<style lang="scss">
.facilities-count-with-owner-indicator {
  display: flex;
  align-items: center;

  span {
    margin-left: $spacing;
  }
}
</style>
